import { Link } from "react-router-dom";
import "../../styles/components/_breadcrumbs.scss";

export default function Breadcrumbs({ items }) {
    return (
        <nav aria-label="Breadcrumb">
            <ol className="breadcrumbs">
                {items.map((item, i) => {
                    const isLast = i === items.length - 1;

                    return (
                        <li key={i} className="item">
                            {isLast ? (
                                <span aria-current="page" className="active">
                                    {item.label}
                                </span>
                            ) : (
                                <>
                                    <Link to={item.href} className="link">
                                        {item.label}
                                    </Link>
                                    <span aria-hidden="true">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <path
                                                opacity="0"
                                                d="M0 0h24v24H0z"
                                            ></path>
                                            <path d="M20.207 14.543l-7.5-7.5c-.39-.39-1.023-.39-1.414 0l-7.5 7.5c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293s.512-.098.707-.293L12 9.164l6.793 6.793c.195.195.45.293.707.293s.512-.098.707-.293c.39-.39.39-1.023 0-1.414z"></path>
                                        </svg>{" "}
                                    </span>
                                </>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
